import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { getAccountAccessState, type AccountAccessState } from '../services/accessStateService'

export type UseAccountAccessStateResult = {
  loading: boolean
  error: string | null
  state: AccountAccessState | null
  reload: () => Promise<void>
}

export function useAccountAccessState(): UseAccountAccessStateResult {
  const { user } = useAuth()
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)
  const [state, setState] = React.useState<AccountAccessState | null>(null)

  const load = React.useCallback(async () => {
    if (!user?.id) {
      setState(null)
      setLoading(false)
      return
    }
    setLoading(true)
    setError(null)
    try {
      const next = await getAccountAccessState()
      setState(next)
    } catch (e: any) {
      setError(e?.message || 'Falha ao carregar status do plano')
    } finally {
      setLoading(false)
    }
  }, [user?.id])

  React.useEffect(() => {
    load()
  }, [load])

  return { loading, error, state, reload: load }
}
